<template>
  <v-app id="inspire">
    <notifications
      position="bottom left"
      width="400px"
      classes="prd-notification"
    />

    <!-- APP Nav -->
    <TheNav :navDrawer="navDrawer" @toggleMenu="toggleMenu($event)" />

    <!-- APP toolbar -->
    <TheTopBar :navDrawer="navDrawer" @toggleMenu="toggleMenu($event)" />

    <!-- APP Content -->
    <v-main>
      <v-container :fluid="fluid" class="fill-height">
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  components: {
    TheNav: () => import("@/layouts/intranet/components/Nav.vue"),
    TheTopBar: () => import("@/layouts/intranet/components/TopBar.vue"),
  },
  props: {
    fluid: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    navDrawer: null,
    notification: {
      position: "bottom left",
      duration: 5000,
    },
  }),
  methods: {
    toggleMenu(value) {
      this.navDrawer = value
    },
  },
  created() {
    //dark mode true/false
    this.$vuetify.theme.dark = this.$store.state.userSettings.darkMode

    //font resize
    const fontSize = this.$store.state.userSettings.fontSize
    const html = document.getElementsByTagName("html")[0]
    if (fontSize) {
      html.style.fontSize = fontSize + "em"
    }
  },
}
</script>

<style lang="scss">
.prd-notification {
  padding: 10px;
  margin: 10px;
  font-size: 0.9em;

  color: white;
  background: #195ae0 !important;
  border-left: 5px solid #1343a7 !important;

  &.warn {
    background: #ffbf3f !important;
    border-left-color: #e39e37 !important;
  }

  &.error {
    background: #ff4344 !important;
    border-left-color: #bb2e31 !important;
  }

  &.success {
    background: #00bba7 !important;
    border-left-color: #018d7e !important;
  }
}
</style>
